export const parseNullableInteger = (value) => {
    if (value === null || value === undefined) return null;

    const normalized = String(value).trim();
    if (normalized === '') return null;

    const parsed = Number.parseInt(normalized, 10);
    return Number.isNaN(parsed) ? null : parsed;
};

export const normalizeNumberInputValue = (value) => (
    value === null || value === undefined ? '' : String(value)
);

export const hasValue = (value) => (
    value !== null && value !== undefined && value !== ''
);

export const normalizeWhitespace = (value) => {
    if (typeof value !== 'string') {
        return value;
    }

    return value.trim().replace(/\s+/g, ' ');
};

export const trimString = (value) => {
    if (typeof value !== 'string') {
        return value;
    }

    return value.trim();
};

export const sanitizeUserIdentityFields = (user = {}) => ({
    ...user,
    nom: normalizeWhitespace(user.nom ?? '') ?? '',
    'primer-cognom': normalizeWhitespace(user['primer-cognom'] ?? '') ?? '',
    'segon-cognom': normalizeWhitespace(user['segon-cognom'] ?? '') ?? '',
    mote: trimString(user.mote),
    mail: trimString(user.mail),
});
